import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { axios } from "./../../../api";
import { Flex, Box, Image, P, ResponsiveSVG } from "ui/acro";
import { H2, Text } from "ui/bend";
import editSVG from "../../../../../app/assets/images/edit.svg";
import { AlomovesIconSVG } from "images/latest";
import EditPlayList from "./EditPlayList";

const PlaylistInfoContainer = styled(Flex)`
  flex-direction: column;
  ${(props) => props.theme.mediaQueries.small} {
    width: 30%;
  }
  .no-image {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f2f2f2;
    aspect-ratio: 16/9;
  }
`;
const TitleContainer = styled(Flex)`
  justify-content: space-between;
  align-items: center;
`;
const Title = styled(H2)`
  color: ${(props) => props.theme.colors.black};
  font-family: ${(props) => props.theme.fonts.Proxima};
  font-size: 28px;
  font-weight: 600;
  line-height: 135%;
  letter-spacing: -0.84px;
  margin: 0px;
  width: 90%;
`;
const DescriptionText = styled(Text)`
  color: ${(props) => props.theme.colors.mine};
  font-family: ${(props) => props.theme.fonts.Proxima};
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.352px;
`;

const DeleteText = styled(Text)`
  color: ${(props) => props.theme.colors.alert.medium};
  font-family: ${(props) => props.theme.fonts.Proxima};
  font-size: 16px;
  font-weight: 400;
  line-height: 24px; /* 150% */
  letter-spacing: 0.352px;
  margin-top: 32px;
  cursor: pointer;
  display: none;
  ${(props) => props.theme.mediaQueries.small} {
    display: block;
  }
`;
const SaveRemoveButton = styled(Flex)`
  color: ${(props) => props.theme.colors.black};
  font-family: ${(props) => props.theme.fonts.Proxima};
  padding: 12px 24px;
  justify-content: center;
  align-items: center;
  border-radius: 360px;
  border: 1px solid ${(props) => props.theme.colors.dawn};
  margin-top: 32px;
  margin-bottom: 32px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px; /* 150% */
  letter-spacing: 0.8px;
  text-transform: uppercase;
`;

const PlaylistInfo = ({
  coverPhoto,
  description,
  classCount,
  author,
  title,
  totalDuration,
  uuid,
  userIsAuthor,
  following,
  signedIn,
  onDelete,
  onEdit
}) => {
  const [isFollowing, setIsFollowing] = useState(following);
  const [editPlaylist, setEditPlayList] = useState(false);


  const getButtonLabel = () => {
    let label = "Add To My Playlists";
    if (isFollowing) {
      label = "Remove from My Playlists";
    }
    return label;
  };

  const AddToMyPlaylist = async () => {
    try {
      const res = await axios.post(`/playlists/${uuid}/followers`);
      if (res.status === 201) {
        setIsFollowing(true);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const RemoveFromMyPlaylist = async () => {
    try {
      const res = await axios.delete(`/playlists/${uuid}/followers`);
      if (res.status === 204) {
        setIsFollowing(false);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleSaveRemoveButtonClick = () => {
    if (isFollowing) {
      RemoveFromMyPlaylist();
    } else {
      AddToMyPlaylist();
    }
  };

  return (
    <PlaylistInfoContainer>
      {coverPhoto ? (
        <Box position="relative" mb={["8px", "10px"]}>
          <Image
            src={coverPhoto}
            objectFit="cover"
            position="absolute"
            top="0"
            left="0"
            style={{ aspectRatio: "16/9" }}
          />
        </Box>
      ) : (
        <Box mb={["8px", "10px"]} className="no-image">
          <ResponsiveSVG
            width={["100%"]}
            height={["193px"]}
            SVG={AlomovesIconSVG}
            className="no-thumbnail"
          />
        </Box>
      )}
      <TitleContainer>
        <Title>{title}</Title>
        {userIsAuthor && (
          <ResponsiveSVG
            onClick={() => setEditPlayList(true)}
            SVG={editSVG}
            width={["24px"]}
            height={["24px"]}
            style={{ cursor: "pointer" }}
          />
        )}
      </TitleContainer>
      <DescriptionText>{description}</DescriptionText>
      <DescriptionText style={{ marginTop: "12px" }}>
        Curated By {`${author.firstName} ${author.lastName}`}
      </DescriptionText>
      <DescriptionText>
        {classCount} class{classCount > 1 ? "es" : ""} - {totalDuration}
      </DescriptionText>
      {userIsAuthor && (
        <DeleteText
          onClick={() => {
            onDelete();
          }}
        >
          Delete
        </DeleteText>
      )}
      {signedIn && !userIsAuthor && (
        <SaveRemoveButton
          onClick={() => {
            handleSaveRemoveButtonClick();
          }}
        >
          {getButtonLabel()}
        </SaveRemoveButton>
      )}
      <EditPlayList
        isOpen={editPlaylist}
        title={title}
        uuid={uuid}
        onClose={() => setEditPlayList(false)}
        description={description}
        onSuccess={onEdit}
      />
    </PlaylistInfoContainer>
  );
};
PlaylistInfo.propTypes = {};

export default PlaylistInfo;
